"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInternalContext = startInternalContext;
function startInternalContext(sessionManager) {
    return {
        get: (startTime) => {
            const trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map